import { render, staticRenderFns } from "./Counter-Footer.vue?vue&type=template&id=e438f8f6"
import script from "./Counter-Footer.vue?vue&type=script&lang=js"
export * from "./Counter-Footer.vue?vue&type=script&lang=js"
import style0 from "./Counter-Footer.vue?vue&type=style&index=0&id=e438f8f6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports